import React, { useContext, useState } from 'react'
import Button from '../../atoms/Button/Button'
import NewModal from '../../molecules/NewModal/NewModal'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import { CartContext } from '../../../context/CartContext'
import UploadLoghi, { _uploadLoghiDimensioni } from '../UploadLoghi/UploadLoghi'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import LoadingSvg from '../../atoms/Loading/Loading'
import useTrans from '../../../hooks/useTrans'
import _ from 'lodash'
import { numberNotation } from '../../../utils/safe'
import ConfigurazioneProdottoConferma from '../ConfigurazioneProdottoConferma/ConfigurazioneProdottoConferma'
import { useEffect } from 'react'
import NoFornitoreModal from '../NoFornitoreModal/NoFornitoreModal'
import { useMemo } from 'react'
import ErrorAlertsList, { CART_ALERT_ERROR_TYPES } from './ErrorAlertsList'

const UploadModal = ({ isVisible, setVisible, uploadInfo, cartMain, checkErroriCarrello }) => {
  const t = useTrans()
  const [Loading, setLoading] = useState(false)
  const [success, setSuccess] = useState()
  const [posizioni, setPosizioni] = useState(
    cartMain
      ? cartMain.personalizzazioni_carrello.find(
          (personalizzazione) => personalizzazione?.id === uploadInfo.personalizzazione_id
        )?.posizioni
      : []
  )
  const articoliPreventivo = useMemo(() => {
    return cartMain
      ? [
          cartMain.personalizzazioni_carrello.find(
            (personalizzazione) => personalizzazione?.id === uploadInfo.personalizzazione_id
          )?.righe_carrello?.[0]?.articolo,
        ]
      : []
  }, [])

  useEffect(() => {
    // inizializzo i campi selectedAltezza e selectedLarghezza
    if (!('selectedAltezza' in posizioni?.[0])) {
      setPosizioni((posizioni) =>
        posizioni.map((posizione) => ({
          ...posizione,
          selectedAltezza:
            posizione.selectedAltezza ||
            posizione.altezza ||
            posizione.personalizzazione.dimensione_altezza,
          selectedLarghezza:
            posizione.selectedLarghezza ||
            posizione.larghezza ||
            posizione.personalizzazione.dimensione_altezza,
          nome: posizione?.nome || posizione?.personalizzazione?.posizione.nome,
        }))
      )
    }
  }, [posizioni])

  const handleChangePosizione = (index, key, value) => {
    const updated = [...posizioni]
    updated[index][key] = value
    setPosizioni(updated)
  }

  const MakePayloadWithFiles = async (filesSelected, note) => {
    const files_to_upload = filesSelected ? Object.values(filesSelected) : []
    if (files_to_upload) {
      // Prepara tutte le promesse di upload
      const uploadPromises = posizioni.map(async (posizione, index) => {
        return _uploadLoghiDimensioni({
          id: posizione.id,
          file_to_upload: files_to_upload?.[index],
          descrizione_posizione: posizione?.descrizione_posizione,
          altezza: posizione?.selectedAltezza,
          larghezza: posizione?.selectedLarghezza,
          pantoni_codici: posizione?.pantoni_codici,
          setLoading: setLoading,
        })
      })
      try {
        await Promise.all(uploadPromises)
        setSuccess(true)
        displayNotification(
          'upload.logo.success',
          t('Hai caricato correttamenti i Loghi'),
          'success'
        )
      } catch (err) {
        console.log(err.message)
        displayNotification('upload.loghi.error', err.message, 'error')
      }
    }
  }

  return !success ? (
    <NewModal
      visible={isVisible}
      closeOnOverlayClick={false}
      onClose={() => setVisible(false)}
      title={t('Caricamento loghi')}
      className={'configurazione-prodotto__modal'}
    >
      <ConfigurazioneProdottoConferma
        onConfirm={(filesSelected) => {
          MakePayloadWithFiles(filesSelected)
        }}
        handleChange={handleChangePosizione}
        stessoLogo={posizioni.length === 1}
        posizioni={posizioni}
        isCart={true}
        setVisible={setVisible}
        articoliPreventivo={articoliPreventivo}
      />
    </NewModal>
  ) : (
    <NewModal
      visible={isVisible}
      title={t('Hai caricato i Loghi con Successo')}
      actions={[
        <Button
          variant="primary"
          label={t('Chiudi')}
          onClick={() => {
            checkErroriCarrello()
            setSuccess(null)
            setVisible(false)
          }}
        />,
      ]}
    />
  )
}

const MercePrenotataModal = ({ isVisible, setVisible, articoli, t }) => {
  const codice_articoli = articoli.map((articolo) => articolo.articolo.codice)

  return (
    <NewModal
      title={t("L'ordine contiene merce prenotata")}
      text={
        <p>
          {t('La quantità inserita per')}
          {codice_articoli?.length > 1 ? t(` gli articoli`) : t(` il codice prodotto`)}
          <strong>{' ' + codice_articoli + ' '}</strong>
          {t(
            "non è disponibile subito, e verrà prenotata. L'ordine verrà evaso dal prossimo arrivo della merce che soddisfa le quantità richieste"
          )}
        </p>
      }
      visible={isVisible}
      onClose={() => setVisible(false)}
      actions={[
        <Button
          label={t('Chiudi')}
          variant="secondary"
          size="medium"
          onClick={() => setVisible(false)}
        />,
      ]}
    >
      <ModalBlocks.ProssimiArrivi articoli={articoli} />
    </NewModal>
  )
}

const CartAlerts = ({ errori, setOpenModalQuantita, setId, checkErroriCarrello, saveCodice }) => {
  const { cartMain } = useContext(CartContext)
  const [isUploadModalVisible, setUploadModalVisible] = useState(false)
  const [isMercePrenotataModalVisible, setMercePrenotataModalVisible] = useState(false)
  const [isNoFornitoreModalVisible, setNoFornitoreModalVisible] = useState(false)
  const [erroreSelected, setErroreSelected] = useState()
  const [articoli, setArticoli] = useState([])
  const t = useTrans()

  const handleAlertClick = (errore) => {
    if (!errore) return
    saveCodice && saveCodice(errore?.riga?.articolo?.codice)
    setErroreSelected(errore)
    if (errore.tipo === CART_ALERT_ERROR_TYPES.NO_LOGO_PANTONI) {
      setUploadModalVisible(true)
    } else if (errore?.tipo === CART_ALERT_ERROR_TYPES.NO_FORNITORE) {
      setNoFornitoreModalVisible(true)
    } else if (errore.tipo === CART_ALERT_ERROR_TYPES.CONTIENE_PRENOTAZIONE) {
      setMercePrenotataModalVisible(true)
      setArticoli(errore?.righe)
    } else if (
      errore?.tipo === CART_ALERT_ERROR_TYPES.NO_SPEDIZIONE_GRATIS ||
      errore?.tipo === CART_ALERT_ERROR_TYPES.QUANTITA_MINIMA_PERSONALIZZABILE
    ) {
      // do nothing
    } else if (errore?.riga?.id) {
      setId(errore.riga.id)
      setOpenModalQuantita(true)
    }
  }

  return (
    <div>
      <ErrorAlertsList errori={errori} cartMain={cartMain} onAlertClick={handleAlertClick} />
      <MercePrenotataModal
        isVisible={isMercePrenotataModalVisible}
        setVisible={setMercePrenotataModalVisible}
        articoli={articoli}
        t={t}
      />
      {erroreSelected && isUploadModalVisible && (
        <UploadModal
          isVisible={isUploadModalVisible}
          setVisible={setUploadModalVisible}
          uploadInfo={erroreSelected}
          cartMain={cartMain}
          checkErroriCarrello={checkErroriCarrello}
          key={`${erroreSelected.nome_lavorazione}-${erroreSelected.tipo}`}
        />
      )}
      {erroreSelected && isNoFornitoreModalVisible && (
        <NoFornitoreModal
          isVisible={isNoFornitoreModalVisible}
          setVisible={setNoFornitoreModalVisible}
          tecnica={
            cartMain?.personalizzazioni_carrello?.filter(
              (personalizzazione) => personalizzazione.id === erroreSelected?.personalizzazione_id
            )?.[0]?.posizioni?.[0].personalizzazione?.tecnica
          }
          maxQuantita={erroreSelected?.max_quantita_ordinabile}
        />
      )}
    </div>
  )
}

export default CartAlerts

export const LoghiMancantiModal = ({
  loghiMancanti,
  checkErroriCarrello,
  cartMain,
  setLoghiMancanti,
}) => {
  return loghiMancanti?.map((logoMancante, i) => (
    <UploadModal
      isVisible={i === 0}
      setVisible={(value) => {
        !value && setLoghiMancanti([])
      }}
      uploadInfo={logoMancante}
      cartMain={cartMain}
      checkErroriCarrello={checkErroriCarrello}
      key={`${logoMancante.nome_lavorazione}-${logoMancante.tipo}`}
    />
  ))
}
